export const getters = {
  getCampaigns: state => state.campaigns,
  getCampaignsCounts: state => state.campaignsCounts,
  getPrimaryCampaigns: state => state.primaryCampaigns,
  getSubCampaigns: state => state.subCampaigns,
  getCampaignSummary: state => state.campaign.summaryDetails,
  getMessageSummary: state => state.campaign.messageDetails,
  getMessageHistory: state => state.message.history,
  getMessageAudience: state => state.campaign.audience,
  getCampaignHistory: state => state.campaign.history,
  getCampaignAudience: state => state.campaign.audience,
  getAudienceSummary: state => state.audienceSummary,
  getMessagingAudienceSummary: state => state.messagingAudienceSummary,
  getCampaignContent: state => state.campaign.content,
  getCampaignReport: state => state.campaign.report,
  getCampaignBasicValidation: state => state.campaign.basicValidation,
  getCampaignValidationByType: (state, getters) => (type) => {
    return getters.getCampaignBasicValidation.filter(validation => validation.TestId === type)
  },
  getCampaignInboxPreviewAndForecaster: state => state.campaign.inboxPreviewAndForecaster,
  getGridSelectedCampaign: state => state.gridSelectedCampaign,
  getMessagingGridSelectedCampaign: state => state.messagingGridSelectedCampaign,
  getCurrentClientId: state => state.clientId,
  getCurrentCompanyId: state => state.companyId,
  getLoadingStatus: state => state.loading,
  getLoadingCustomerStatus: state => state.loadingCustomers,
  getLocale: state => state.locale,
  getDateFormat: state => state.dateFormat,
  getTimeFormat: state => state.timeFormat,
  getUserEmail: state => state.userEmail,
  getValidationCampaignId: state => state.validationCampaignId,
  getCampaignJourney: state => state.campaignJourney,
  getUserAccessControl: state => state.userAccessControl,
  getTransactionalMailingInTestMode: state => state.transactionalMailingInTestMode,
  getHasEmailContentApproval: state => state.hasEmailContentApproval,
  getIsInboxForecasterEnabled: state => state.isInboxForecasterEnabled,
  getLandingTab: state => state.landingTab,
  getIsPrimary: state => state.isPrimary,
  getEinsightUri: state => state.einsightUri,
  getAppConfig: state => state.appConfig,
  getCurrentChildTemplateId: state => state.currentChildTemplateId,
  getAccountId: state => state.accountId,
  getFiltersData: state => state.filtersData,
  getMessagingFiltersData: state => state.messagingFiltersData,
  getSMSMessaging: state => state.SMSMessaging,
  getWhatsAppMessaging: state => state.WhatsAppMessaging,
  getB2BCampaignType: state => state.b2bCampaignType,
  getEmailCampaignType: state => state.EmailCampaignType,
  getMessagingGridHoveredRow: state => state.messagingGridRowHoverData,
  getMessagingStatistics: state => state.messagingStatistics,
  getHasSalesStatus: state => state.hasSalesCampaign
}
